export default __webpack_public_path__ + "static/19208-ff5b7899f6a6cc910a09c6afa1da965a.jpg";